var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2022",
    "data-name": "Groupe 2022",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.109,
    height: 21.094,
    viewBox: "0 0 21.109 21.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 21.109,
    height: 21.094,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2021",
    "data-name": "Groupe 2021",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1958",
    "data-name": "Trac\\xE9 1958",
    d: "M21.093.506c0-.008,0-.016,0-.024l.017-.006L21.062.358l0-.006a.216.216,0,0,0-.02-.045.538.538,0,0,0-.1-.148A.523.523,0,0,0,20.78.051a.313.313,0,0,0-.05-.019A.581.581,0,0,0,20.583,0a.181.181,0,0,0-.031,0,.483.483,0,0,0-.168.028L.369,6.7A.539.539,0,0,0,.345,7.715L9.76,11.335,13.38,20.75a.543.543,0,0,0,.5.345h.012a.539.539,0,0,0,.5-.368L21.069.706v0A.643.643,0,0,0,21.1.55V.543a.21.21,0,0,0,0-.031Zm-2.53,1.267L10.044,10.29,2.134,7.249Zm.763.761L13.849,18.963l-3.041-7.91Z",
    transform: "translate(0 -0.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareBlack);
export default __webpack_public_path__ + "static/media/icon-share-black.d083d954c5187210e13b5a63e0c2ac4b.svg";
export { ForwardRef as ReactComponent };